import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

const WandStarsIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 25" boxSize={5} {...props}>
    <path
      d="M4.4 21.5L3 20.1L10.525 12.55L6 11.425L10.95 8.35L10.525 2.5L15 6.275L20.4 4.075L18.225 9.5L22 13.95L16.15 13.55L13.05 18.5L11.925 13.975L4.4 21.5ZM5 8.5L3 6.5L5 4.5L7 6.5L5 8.5ZM13.875 13.425L15.075 11.45L17.4 11.625L15.9 9.85L16.775 7.7L14.625 8.575L12.85 7.1L13.025 9.4L11.05 10.625L13.3 11.175L13.875 13.425ZM18 21.5L16 19.5L18 17.5L20 19.5L18 21.5Z"
      fill="currentColor"
    />
  </Icon>
);

export default WandStarsIcon;
